var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-group',{attrs:{"config":{ listening: false }}},[_vm._l((_vm.maxHorizCount),function(index){return _c('v-line',{key:`vert-${index}`,attrs:{"config":{
      points: [index * _vm.GRID_UNIT_PX, 0, index * _vm.GRID_UNIT_PX, _vm.dimensions.height],
      stroke: _vm.STROKE_COLOR,
      strokeWidth: _vm.STROKE_WIDTH
    }}})}),_vm._l((_vm.maxVertCount),function(index){return _c('v-line',{key:`horiz-${index}`,attrs:{"config":{
      points: [0, index * _vm.GRID_UNIT_PX, _vm.dimensions.width, index * _vm.GRID_UNIT_PX, ],
      stroke: _vm.STROKE_COLOR,
      strokeWidth: _vm.STROKE_WIDTH
    }}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }